module.exports = __webpack_public_path__ + "img/logo.svg?b36f5ee02d96265310f69c12e637fba0";